<template>
  <div class="w-full">
    <label
      class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1"
      for="name"
    >
      {{ props.label }}
    </label>
    <div class="relative w-full">
      <input 
        @input="customChange"
        class="appearance-none block w-full bg-white text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-1 sm:py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed relative"
        :id="props.id"
        type="text"
        :value="value"
        :placeholder="props.placeholder"
        :disabled="props.disabled"
      />
    </div> 
  </div>
</template>
<script setup lang="ts">
import { ref, watch, defineEmits, defineProps, onMounted, PropType } from "vue";

const ON_CHANGED = "onChanged";
const props = defineProps({
  value: {
    type: String || Number,
    required: true,
  },
  id: String,
  label: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  placeholder: String, 
  validator: Function as PropType<(value: string) => boolean | undefined>, // Corrected validator prop type

});
const value = ref(props.value);

const emit = defineEmits<{
  (e: typeof ON_CHANGED, v: string): void;
}>();
onMounted(() => {
  value.value = props.value;
});

// ANSKNI-181: reflect parent updates that arrive after mount (e.g. ANSKNI-176
// auto-fills address/zip asynchronously once the builder data has loaded).
// Without this watch the field keeps the initial snapshot and shows blank.
watch(
  () => props.value,
  (v) => {
    if (v !== value.value) {
      value.value = v;
    }
  }
);
function customChange(v: any) {
  let inputValue = (v.target as HTMLInputElement).value;
  if (props.validator) {
    if (!props.validator(inputValue)) {
      (v.target as HTMLInputElement).value = value.value as string; // Reset to previous value
      return;
    }
  }
    value.value = v.target.value;
    emit(ON_CHANGED, value.value);
  

}
</script>
